// Travel extras: transfers, car hire, tickets, passes, eSIMs, luggage storage and delay claims from partners we work
// with (tracked links from the backend; only brands our programme has joined). Same price for the traveller.
import React, { useEffect, useState } from "react";
import { Car, KeyRound, Ticket, Wifi, ShieldCheck, Plane, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = { car: Car, key: KeyRound, ticket: Ticket, wifi: Wifi, shield: ShieldCheck, plane: Plane };

export function TravelExtras({ city, title = "Sort the rest of your trip" }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let on = true;
    api("/travel/extras" + (city ? "?city=" + encodeURIComponent(city) : ""), { auth: false })
      .then((r) => { if (on) setData(r); })
      .catch(() => {});
    return () => { on = false; };
  }, [city]);
  if (!data || !data.groups || !data.groups.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6" data-testid="travel-extras" aria-labelledby="travel-extras-title">
      <h2 id="travel-extras-title" className="text-2xl font-bold tracking-tight">{city ? title + " in " + city : title}</h2>
      <p className="mt-1 text-sm text-muted-foreground">Transfers, car hire, tickets, data and help, from partners we trust.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {data.groups.map((g) => {
          const Icon = ICONS[g.icon] || Ticket;
          return (
            <div key={g.key} className="rounded-2xl border p-5" data-testid={"travel-extras-" + g.key}>
              <div className="flex items-center gap-2">
                <Icon className="h-5 w-5" aria-hidden="true" />
                <h3 className="text-base font-bold">{g.label}</h3>
              </div>
              <ul className="mt-3 divide-y">
                {g.items.map((i) => (
                  <li key={i.brand}>
                    <a href={i.url} target="_blank" rel="sponsored noopener noreferrer" className="flex items-center justify-between gap-3 py-2.5 hover:opacity-80">
                      <span className="min-w-0">
                        <span className="block text-sm font-semibold">{i.label}</span>
                        <span className="block truncate text-xs text-muted-foreground">{i.blurb}</span>
                      </span>
                      <ArrowUpRight className="h-4 w-4 shrink-0" aria-hidden="true" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
      <p className="mt-4 text-xs text-muted-foreground">{data.disclosure}</p>
    </section>
  );
}
